import React, { Component } from 'react'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
//import {FacebookShareButton, FacebookIcon, TwitterShareButton,TwitterIcon } from "react-share";
const { changeColorSVG } = global.rootRequire('classes/ulti')
global.isclient && require('./rxImageGallery.css')

class RxImageGallery extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      images: [],
      total: 0,
      index: 0
    }
    const screenHeight = window.innerHeight - 20
    this.state['styleImg'] = { maxHeight: screenHeight + 'px', maxWidth: '100%', height: 'auto' }
    this.keyClickFunction = this.keyClickFunction.bind(this);
    if (this.props.images) {
      const images = this.props.images.split(',')
      if (images && images.constructor === Array && images.length > 0) {
        images.forEach(url => {
          if (url) {
            this.state.images.push(global.rxu.config.get_static + url)
          }
        })
      }
    }
    if (this.props.position && !isNaN(this.props.position)) {
      this.slideIndex = Number(this.props.position) + 1
    } else {
      this.slideIndex = 1
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keyClickFunction, false);
    this.setState({
      total: this.state.images.length
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        this.plusSlides(1)
      }
      if (event.key === 'ArrowLeft') {
        this.plusSlides(-1)
      }
    })

    this.showSlides(this.slideIndex)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
  }

  keyClickFunction(event) {
    event.preventDefault();

  }
  plusSlides(n) {
    this.slideIndex += n
    if (this.slideIndex === 0) {
      this.slideIndex += n
    }
    this.showSlides(this.slideIndex)
  }

  currentSlide(n) {
    this.slideIndex = n
    this.showSlides(this.slideIndex)
  }

  downShowGallery() {
    let indexTab = this.state.index
    let images = this.state.images

    let imageCurrent = images[Number(indexTab) - 1]

    try {
      let xhr = new XMLHttpRequest()
      xhr.open("GET", imageCurrent, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL
        var imageUrl = urlCreator.createObjectURL(this.response)
        var tag = document.createElement('a')
        tag.href = imageUrl
        tag.download = 'image_' + Math.floor(Date.now() / 1000)
        document.body.appendChild(tag)
        tag.click()
        document.body.removeChild(tag)
      }
      xhr.send()
    } catch (e) { }
  }

  showSlides(n) {
    let total = this.state.images.length || []
    this.slideIndex = n
    if (n > total) {
      this.slideIndex = 1
    } else if (n < 0) {
      this.slideIndex = total
    }

    this.setState({
      index: this.slideIndex
    })
  }

  resetMaxHeightComponent() {
    this.setState({ styleImg: { maxWidth: '100%', height: 'auto' } })
  }

  render() {
    const screenHeight = window.innerHeight - 20
    return (
      <div className='gallery-container'>
        <div className='number_item'>
          <span className='number'>{this.state.index}/{this.state.total}</span>
        </div>
        <div className='gl-download'>
          <span onClick={e => this.downShowGallery()} className='icon-cloud-download'></span>
        </div>
        <div className='gl-close'>
          <span onClick={e => this.props.closeShowGallery()}>
            <img className='filter_img_class' src={changeColorSVG('./images/default/static/icon-close.svg')} alt='' />
          </span>
        </div>
        <div>
          <div className='gl-slides gl-fade'>
            {(this.props.type === 'video')
              ? <div className='div_video'>
                <video controls className='video' key={this.state.images[this.slideIndex - 1]}>
                  <source src={this.state.images[this.slideIndex - 1]} type='video/mp4' />
                </video>
              </div>
              : <div style={{ width: '100vw', height: '100vh' }}>
                <div id='wrapper-image' style={{ width: '100%', height: '100%', marginTop: '30px' }}>
                  <TransformWrapper
                    initialScale={0.9}
                    minScale={0.3}
                    maxScale={5}
                    centerOnInit={true}
                  >
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                      <React.Fragment>
                        <div className="tools-zoom-image">
                          <span style={{ marginLeft: '15px', cursor: 'pointer' }} onClick={() => { this.resetMaxHeightComponent(); zoomIn() }}>
                            <svg fill='#0866ff' viewBox="0 0 35 35" height='35px'><path d="M11 6H9v3H6v2h3v3h2v-3h3V9h-3z"></path><path d="M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"></path></svg>
                          </span>
                          <span style={{ marginLeft: '15px', cursor: 'pointer' }} onClick={() => zoomOut()}>
                            <svg fill='#0866ff' viewBox="0 0 35 35" height='35px'><path d="M6 9h8v2H6z"></path><path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"></path></svg>
                          </span>


                        </div>
                        <TransformComponent >
                          <img src={this.state.images[this.slideIndex - 1]} alt='' style={this.state.styleImg} />
                        </TransformComponent>
                      </React.Fragment>
                    )}
                  </TransformWrapper>
                </div>
              </div>
            }
          </div>

          {(this.state.images.length > 1) && <span className='gl-prev' onClick={e => this.plusSlides(-1)}>&#10094;</span>}
          {(this.state.images.length > 1) && <span className='gl-next' onClick={e => this.plusSlides(1)}>&#10095;</span>}
        </div>
        {(this.state.images.length < 5) && (<div className='gl-dot-btns'>
          {(this.state.images.length > 0) && this.state.images.map((url_img, index) => (
            <span key={index} className='gl-dot' onClick={e => { this.currentSlide(index + 1) }} />
          ))}
        </div>)
        }

      </div>
    )
  }
}

RxImageGallery.defaultProps = { closeShowGallery: () => { }, images: '' }

export default RxImageGallery
